"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeReferralInfo = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
const removeReferralInfo = voucherName => {
  if (!voucherName) {
    return;
  }
  const currentReferral = _jsCookie.default.get(_presentationUtils.PbsCookieNames.PBS_OWNER);
  if (currentReferral !== voucherName) {
    return;
  }
  _jsCookie.default.remove(_presentationUtils.PbsCookieNames.PBS_OWNER);
  (0, _presentationUtils.removeQueryParameter)('store');
};
exports.removeReferralInfo = removeReferralInfo;
